import React, { useState, useEffect } from "react"
import { Transition } from "@headlessui/react"
import Chevron from "./icons/chevron"


export function ScrollToTop() {
  const [isShowing, setIsShowing] = useState(false)

  useEffect(() => {
    window.onscroll = function () {
      setIsShowing(window.scrollY !== 0 ? true : false)
    }
  })
  return (
    <div>
      <Transition
        show={isShowing}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <a
          href="#top"
          className="print:hidden font-bold shadow-spread fixed cursor-pointer transition inline-flex items-center justify-center border border-transparent uppercase btn-gray sm:text-sm p-1 sm:px-3 w-12 h-12 sm:w-auto sm:h-auto rounded-full sm:rounded-md right-4 bottom-4 z-40"
        >
          <span className="sr-only sm:hidden">Scroll to top</span>
          <span className="hidden sm:inline">Go to top</span>
          <Chevron strokeWidth={5} className="sm:ml-2 w-2.5 sm:w-2 -rotate-90" />
        </a>
      </Transition>
    </div>
  )
}
